// src/context/LoadingContext.tsx

"use client";

import React, { createContext, useState, useContext, ReactNode } from "react";
interface LoadingContextType {
  isLoading: boolean;
  setLoading: (loading: boolean) => void;
}
const LoadingContext = createContext<LoadingContextType | undefined>(undefined);
export const LoadingProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const setLoading = (loading: boolean) => {
    setIsLoading(loading);
  };
  return <LoadingContext.Provider value={{
    isLoading,
    setLoading
  }} data-sentry-element="unknown" data-sentry-component="LoadingProvider" data-sentry-source-file="LoadingContext.tsx">
            {children}
        </LoadingContext.Provider>;
};
export const useLoading = (): LoadingContextType => {
  const context = useContext(LoadingContext);
  if (context === undefined) {
    throw new Error("useLoading must be used within a LoadingProvider");
  }
  return context;
};